import React,{useState,useEffect} from 'react';
interface props {
  userInfo?: any
  enums?:any
}

const SPOpenBusinessModal: React.FC<props> = (props) => {

  const { userInfo, enums } = props;

  const [open, setOpen] = useState<any>(false);

  useEffect(() => {
    const isOpen = localStorage.getItem('isOpen');
    const isWhiteList = enums.f_supplier_white_list?.length == 0 ||  enums.f_supplier_white_list?.find((item:any) => item.key == userInfo?.supplier_code);
    if (!isOpen && userInfo.user_name && isWhiteList) {
      setOpen(true);
      localStorage.setItem('isOpen', 'true');
    }
  }, [userInfo]);

    return (
    open && <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <div style={{
          width: 700,
          height: 450,
          display: 'flex',
          position: 'relative',
          justifyContent:'center'
        }}>
          <img src="https://dpubstatic.udache.com/static/dpubimg/uftmzOrpLc47PBSigM-_c_openModal.png" alt="" />
          <div style={{
            position:'absolute',
            width: 100,
            height: 100,
            // backgroundColor: 'red',
            borderRadius: '50%',
            left: 300,
            top: 322,
            opacity:1
          }} onClick={()=> setOpen(false)}></div>
        </div>
      </div >
    )
}

export default SPOpenBusinessModal